export default {
    home: {
        text_1: "Redefining the Future<br/> of Crypto Trading",
        text_2: "Start trading",
        text_3: "{x} has joined",
    },
};
